//ENV based Variables
const config = require("./config.json");
const APP_ENV = process.env.REACT_APP_ENV;
const envConfig = config[APP_ENV];

export const baseUrl = envConfig.API_BASE_URL;
